/**
 * Estimate reading time from HTML content.
 * Uses 200 words/min (industry standard for adult readers).
 * Returns a localized string like "5 min read" or "5 Min. Lesezeit".
 */
export function getReadingTime(htmlContent, lang = 'en') {
  if (!htmlContent) {
    return lang === 'de' ? '1 Min. Lesezeit' : '1 min read';
  }
  // Strip HTML tags
  const plainText = htmlContent.replace(/<[^>]+>/g, ' ');
  // Count words (split on whitespace, filter empty)
  const wordCount = plainText.split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(wordCount / 200));
  return lang === 'de' ? `${minutes} Min. Lesezeit` : `${minutes} min read`;
}
